export function deployPathPrefix(): string {
  const bu = import.meta.env.BASE_URL
  if (bu === '/' || bu === './') return ''
  const trimmed = bu.replace(/\/$/, '')
  return trimmed.length > 0 ? trimmed : ''
}

export function routerBasename(): string | undefined {
  const prefix = deployPathPrefix()
  return prefix.length > 0 ? prefix : undefined
}

export function embeddedAppPath(kind: 'legacy' | 'new'): string {
  const suffix = kind === 'legacy' ? '/legacy' : '/new'
  const prefix = deployPathPrefix()
  if (prefix.length === 0) return suffix
  return `${prefix}${suffix}`.replace(/\/+/g, '/')
}
